module.exports = __webpack_public_path__ + "static/media/box_header_1.6e2c967f.png";